import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

const WIDTH = 151;

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'relative',
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'center',
      boxShadow: 'none',
      cursor: 'pointer',
      overflow: 'hidden',
      minWidth: WIDTH,
      marginBottom: theme.spacing(0.5),

      '&$disabled': {
        cursor: 'auto',
        '& $title': {
          color: COLORS.gray.gray40,
        },

        '& $icon rect:first-child': {
          fill: COLORS.gray.background,
        },
      },
    },
    selected: {},
    disabled: {},

    title: {
      textAlign: 'center',
      maxWidth: WIDTH,
    },
    icon: {
      width: '100%',
      minHeight: 64,
      marginBottom: theme.spacing(1),
      borderRadius: theme.shape.borderRadiusSmall,
    },
    comingSoonTag: {
      position: 'absolute',
      top: 4,
      left: 4,
      padding: theme.spacing(0.25, 0.5),
      backgroundColor: COLORS.neutral.darkGray,
      color: COLORS.neutral.white,
      borderRadius: theme.shape.borderRadiusSmall,
    },
  }),
  { name: 'CardSmall' }
);
